import React, { useState, useEffect, useCallback, useRef } from 'react';
import './COEFormLanguage.css';
import header from './assets/images/header_en.png';
import { useNavigate } from 'react-router-dom';


function COEFormLanguage() {
    const navigate = useNavigate();

    const handleLanguageSelect = (language) => {
        navigate('/f/bnVyc2luZy9DT0VGb3Jt', { state: { language } });
    };

    return (
        <div className="form-container-language">
            <div className="language-container">
                <div className="header-container">
                    <img src={header} alt="Header" className="header-image" />
                </div>
                <h2>Please select a language / Sila pilih bahasa / 请选择语言</h2>
                <br />
                <div className="button-container">
                    <button onClick={() => handleLanguageSelect('en')}>English</button>
                    <button onClick={() => handleLanguageSelect('ms')}>Bahasa Melayu</button>
                    <button onClick={() => handleLanguageSelect('zh')}>中文</button>
                </div>
            </div>
            <br />
            <br />
            <br />
        </div>
    );
}

export default COEFormLanguage;